export default {
  title: 'Banners',
  actions: {
    create: 'Create a banner',
    confirmDelete: 'Are you sure you want to delete this banner?',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save'
  },
  empty: {
    title: 'No banner',
    message: 'To create a banner, nothing could be easier, just click on the following link:',
    'url': 'The URL parameter is required!'
  },
  error: {
    url: {
      invalid: 'Please provide valid (domain/url) for the above quesion'
    },
    pathTarget: {
      start: "Path must start with \'/\'",
      all: 'If you want target all the path, prefer use the option above -any page-',
      double: 'Path can\'t have double slash'
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/banner.js